"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type { LuaByDistrictProps } from "./LuaByDistrictChart.impl";

export const LuaByDistrictChart = dynamicChart(
  () => import("./LuaByDistrictChart.impl").then((m) => m.LuaByDistrictChart),
  340,
);
